import { render, staticRenderFns } from "./SendImage.vue?vue&type=template&id=ccef9f2e&scoped=true&"
import script from "./SendImage.vue?vue&type=script&lang=ts&"
export * from "./SendImage.vue?vue&type=script&lang=ts&"
import style0 from "./SendImage.vue?vue&type=style&index=0&id=ccef9f2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccef9f2e",
  null
  
)

export default component.exports